import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
  selector: "art-html-content-dialog",
  templateUrl: "./html-content-dialog.component.html",
  standalone: false,
})
export class HtmlContentDialogComponent {
  title: string;
  safeHtml: SafeHtml;

  constructor(
    public dialogRef: MatDialogRef<HtmlContentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; html: string },
    sanitizer: DomSanitizer,
  ) {
    this.title = data.title;
    this.safeHtml = sanitizer.bypassSecurityTrustHtml(data.html);
  }
}
